import React from 'react';
import ActionsBlock from './ActionsBlock';
import * as DateUtils from 'utils/dates';
const CONFIGURATION = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'notification_id',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
          }}
        >
          {cellValue}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Number',
    id: 'vat_num',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
          }}
        >
          {cellValue}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },

  {
    label: 'Type',
    id: 'notification_type',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].notification_type === 'Payment Reminder MSID' ||
              data[rowIndex].notification_type === 'Payment Reminder MSCON' ||
              data[rowIndex].notification_type === 'VAT Return Submit Reminder'
                ? data[rowIndex].is_read
                  ? 'orange'
                  : 'red'
                : data[rowIndex].is_read
                ? 'black'
                : '#72bcd4',
            fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
          }}
        >
          {cellValue}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },

  {
    label: 'Title',
    id: 'notification_title',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
          }}
        >
          {cellValue}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },

  // {
  //   label: 'Message',
  //   id: 'notification_message',
  //   render: (
  //     rowIndex: number,
  //     cellValue: any,
  //     columnIndex: number,
  //     data: Array<any>
  //   ) => (
  //     <React.Fragment>
  //       <span
  //         style={{
  //           fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
  //         }}
  //       >
  //         {cellValue.substring(0, 100)}
  //         {cellValue.length > 100 ? '...' : ''}
  //       </span>
  //     </React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Notification Date',
    id: 'created_at',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Seen',
    id: 'is_read',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
          }}
        >
          {cellValue ? 'Yes' : 'No'}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        rowIndex={rowIndex}
        data={data}
        dataid={data[rowIndex].notification_id}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const NotificationTableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};
